import React, { Component } from "react";
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";


const addShippingAddress = (data, receivingCustomer, success) => {
  axios({
    method: 'PUT',
    data,
    url: `${ROOT_URL}v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
  .then(res => {
    success();
  }, err => {

  })
}

// const addFBAAddress = (data) => {
//     axios({
//       method: 'POST',
//       data,
//       url: `${ROOT_URL}v1/sale/order-address`,
//       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//     })
//     .then(res => {
//         alert("FBA Address Added");
//         this.props.closeFBAEditModal();
//       }, err => {
//         alert("Error adding FBA Address");  
//       })
//   }

const dataValid = (data) => {
  if (!data.name || !data.city || !data.state || !data.street || !data.zipcode) {
    return;
  }
  return true;
}

const fetchCustomerDetails = (receivingCustomer, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}/v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
  .then(res => {
    success(res);
  }, err => {

  })
}

class FBAAddressEditModal extends Component {
  constructor() {
    super();
    this.state = {
        name: "",
        // address: "",
        city: "",
        state: "",
        street: "",
        zipcode: "",
        phone: "",
        note: "",
    };
  }

  componentDidMount() {
    // fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
  }

  handleInputFieldChange = ({ name, value }) =>
    this.setState({ [name]: value });

    
    // handleFetchCustomerDetailsSuccess = ({ data }) => {
    //   this.setState({
    //     name: "",
    //     address: "",
    //     phone: "",
    //     note: "",
    //     customerDetails: data,
    //   })
    // }

  handleSubmit = () => {

    if (!dataValid(this.state)) {
      alert('name and address details are required')
      return;
    }

    // this.setState({
    //   buttonDisabled: true,
    // })
    // const customerDetails = {
    //   ...this.state.customerDetails
    // }

    const data = {
      ...this.state,
    };
  
    axios({
        method: 'POST',
        data,
        url: `${ROOT_URL}v1/sale/order-address`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then(res => {
          alert("FBA Address Added");
          this.props.closeFBAEditModal();
          this.props.modalFetchFBA();
        }, err => {
          alert("Error adding FBA Address");  
        })

    // addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
    //   this.props.reFetchSalesCustomers();
    //   this.setState({
    //     buttonDisabled: false,
    //   })
    // })
  };

  render() {
    const { name, city, state, street, zipcode, phone, note } = this.state;
    return (
      <div>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="name" />:
            </label>
          </Col>
          {/* <Col sm={6}>
            <label>
              <Translate value="address" />:
            </label>
          </Col> */}
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="name"
              value={name}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          {/* <Col sm={6}>
            <Input
              type="text"
              name="address"
              value={address}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col> */}
        </Row>


        <Row>
          <Col sm={6}>
            <label>
              <Translate value="street" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="city" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="street"
              value={street}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="city"
              value={city}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="state" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="zipcode" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="state"
              value={state}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="zipcode"
              value={zipcode}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>




        <Row>
          <Col sm={6}>
            <label>
              <Translate value="phone" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="note" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="phone"
              value={phone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="note"
              value={note}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row className="centerStyle" style={{ marginTop: "0px" }}>
          <Button
            bsStyle="success"
            disabled={false}
            onClick={(e) => {
              this.handleSubmit();
            }}
            // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default FBAAddressEditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/fbaAddressEditModal.jsx